module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/allyant-badge-e1a507ceaf984f0053b8f990de9c610a.svg";